import { erpAxios } from '..';

const statusGenerisanUgovor = async (data) => {
  const res = await erpAxios.post(`/statusZahtjeva/generisanUgovor`, data);
  return res;
};

export default statusGenerisanUgovor;
